module.exports = __webpack_public_path__ + "img/receipt-icon-green.44d3cde8.svg";